// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"d0b2e8f7","3706":"d0b2e8f7"}[chunkId] + ".chunk.css";
};